import React from 'react';
import partial from 'lodash/partial';
import { Link } from 'react-router';
import { trackClickWithMixpanel } from 'common/tracking';
import ReviewsAggMetadata from 'marketing/containers/reviews_agg_metadata';
import StarRatingPartial from 'marketing/components/star_rating_partial';

const ReviewsAgg = ({ stats, linkEventTracking, itemName, title }) => (
  <div className="reviews-agg">
    <ReviewsAggMetadata itemName={itemName} />
    { title ||
    <h2>
      Loved by over 60,000 businesses <span className="show-for-small-only">worldwide.</span>
      <span className="show-for-medium"> around the world.</span>
    </h2> }
    <StarRatingPartial rating={stats.avg || 0} />
    <h4>
      crowdspring is rated { stats.avg || 0 }/5 from { (stats.count || 0).toLocaleString() }{' '}
      <Link to="/reviews/">
        <span onClick={
          linkEventTracking?
          partial(trackClickWithMixpanel, linkEventTracking.eventName, linkEventTracking.eventData) :
          undefined
        }>
          customer reviews
        </span>
      </Link>.
    </h4>
  </div>
);

export default ReviewsAgg;



// WEBPACK FOOTER //
// ./marketing/components/reviews_agg.jsx